<template>
  <div id="app">
      <router-view/>
    <Footer/>
  </div>
</template>

<script>
  import Header from "@/components/Header";
  import Footer from "@/components/Footer";

  export default {
    name: 'App',
    components: {Footer, Header}
  }
</script>

<style>
  html, body {
    overflow-x: hidden;
  }

  body {
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  }

  html, body,
  dl, dt, dd, ol, ul, li, p {
    margin: 0;
    padding: 0;
  }

  ol, ul {
    list-style: none;
  }

  a {
    color: inherit;
    text-decoration: none;
  }
  .image-wrap img{
    height: 100%;
  }
  .row{
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue